// extracted by css-extract-rspack-plugin
export default {"layout":"layout-cmD_U9","content":"content-Gh9Lw0"};